module.exports = __webpack_public_path__ + "img/img14.bc62fb42.jpg";